<div class="project-analytics-page">
  <div class="header">
    <h2>Project Analytics</h2>
    <button mat-stroked-button (click)="refresh()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="stats-grid" *ngIf="analytics">
    <div class="stat-card">
      <span>Total Projects</span>
      <strong>{{ analytics.totalProjects }}</strong>
    </div>
    <div class="stat-card">
      <span>Active Projects</span>
      <strong>{{ analytics.activeProjects }}</strong>
    </div>
    <div class="stat-card">
      <span>Completed Projects</span>
      <strong>{{ analytics.completedProjects }}</strong>
    </div>
    <div class="stat-card">
      <span>Total Tasks</span>
      <strong>{{ analytics.totalTasks }}</strong>
    </div>
    <div class="stat-card">
      <span>Completed Tasks</span>
      <strong>{{ analytics.completedTasks }}</strong>
    </div>
    <div class="stat-card">
      <span>Completion Rate</span>
      <strong>{{ completionRate }}%</strong>
    </div>
    <div class="stat-card">
      <span>Avg Progress</span>
      <strong>{{ analytics.averageProjectProgress | number:'1.0-0' }}%</strong>
    </div>
    <div class="stat-card">
      <span>Onboarding Items</span>
      <strong>{{ analytics.totalOnboardingItems }}</strong>
    </div>
  </div>

  <section class="panel" *ngIf="projects.length">
    <h3>Project Progress Board</h3>
    <div class="progress-list">
      <div class="progress-item" *ngFor="let project of projects">
        <div class="head">
          <strong>{{ project.name }}</strong>
          <span>{{ project.progressPercent | number:'1.0-0' }}%</span>
        </div>
        <div class="track">
          <div class="fill" [style.width.%]="project.progressPercent || 0"></div>
        </div>
        <div class="meta">
          <span>Status: {{ project.status }}</span>
          <span>Tasks: {{ project.completedTaskCount }}/{{ project.taskCount }}</span>
          <span>Lead: {{ project.leadStaffName || '-' }}</span>
        </div>
      </div>
    </div>
  </section>
</div>
